import React from "react";
import { useMediaQuery } from "beautiful-react-hooks";
import { Link } from "react-router-dom";
import LandHeader from "./LandHeader";
import Footer from "./Footer";
export default function LearnAuth() {
  const isSmall = useMediaQuery("(max-width: 768px)");

  var canonical = document.querySelector('link[rel="canonical"]');
  if (canonical !== null) {
    canonical.href = `https://sinatether.com/learnAuth`;
  }

  document.title = "آموزش احرازهویت در صرافی سینا تتر";
  document.getElementsByTagName("META")[3].content =
    "0 تا 100 آموزش احراز هویت در صرافی سینا تتر برای سهولت در خرید، فروش و معامله مطمئن و سودمند تریدها و سرمایه گذارن ایرانی 🖥️ 📱";

  return (
    <>
      <LandHeader />

      <div
        className={
          "mid-main text-center marginlr-140 learn-main-sina h2-size-title-learn  "
        }
      >
        <div className={""}>
          <h5 className={" h2-size-title-learn"}>
            آموزش احرازهویت در صرافی سینا تـتر
          </h5>
        </div>

        <div className={"body pt-3 text-right"}>
          <img
            className={"w-100 pad23240"}
            src={"https://static.sinatether.com/images/aut1.jpg"}
            alt={""}
          />

          <span className={"dsjfk24242"}>
            1. ابتدا روی گزینه ورود | ثبت نام کلیک کنید.
          </span>

          <img
            className={"w-100 pad23240"}
            src={"https://static.sinatether.com/images/aut2.jpg"}
            alt={""}
          />

          <span className={"dsjfk24242"}>
            2. سپس شماره موبایل خود را وارد کرده و روی گزینه ارسال کلیک کنید.
          </span>

          <img
            className={"w-100 pad23240"}
            src={"https://static.sinatether.com/images/aut3.jpg"}
            alt={""}
          />

          <span className={"dsjfk24242"}>
            3. در آخر کد تایید پیامکی خود را وارد کرده و روی گزینه تایید کلیک
            کنید.{" "}
          </span>

          <img
            className={"w-100 pad23240"}
            src={"https://static.sinatether.com/images/aut4.jpg"}
            alt={""}
          />

          <span className={"dsjfk24242"}>
            4.سپس در صفحه اصلی در قسمت منو روی اخرین گزینه مطابق شکل کلیک کنید.{" "}
          </span>

          <img
            className={"w-100 pad23240"}
            src={"https://static.sinatether.com/images/aut5.jpg"}
            alt={""}
          />

          <span className={"dsjfk24242"}>
            5. برای احراز هویت کاربر ملزم به ارائه شماره تلفن همراه_نام و نام
            خانوادگی _کد ملی _شماره کارت و شماره شبا به نام خود کاربر باشد سپس
            عکس مدارکی که شامل (عکس کارت ملی -عکس کارت بانکی _عکس سلفی همراه با
            متن تعهدنامه )را وارد کنید و روی گزینه ارسال کلیک کنید . پس از تکمیل
            کردن این اطلاعات در صورت تائید احراز هویت شما انجام میشود.
          </span>
        </div>
      </div>

      <Footer />
    </>
  );
}
